import { render, staticRenderFns } from "./BookOrder.vue?vue&type=template&id=15d77382&scoped=true"
import script from "./BookOrder.vue?vue&type=script&lang=js"
export * from "./BookOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d77382",
  null
  
)

export default component.exports